import { render, staticRenderFns } from "./SpeakerNotesPanelIcon.vue?vue&type=template&id=41aed28b"
import script from "./SpeakerNotesPanelIcon.vue?vue&type=script&lang=js"
export * from "./SpeakerNotesPanelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports